import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Nav from './Nav';
import user from '../assets/images/default.png';
import croix from "../assets/images/close.png";
import back from "../assets/images/back.png";
import MenuHeader from './MenuHeader';
import TherapistService from '../services/therapist.service';
import useApi from '../hooks/useApi';
import Modal from "react-modal";
import DateTimeSelector from './DateTimeSelector';
import HeaderTherapist from './HeaderTherapist';
import ReviewList from './ReviewList';
import Informations from './Informations';
import { useNotifications } from '../context/NotificationProvider';
import useAuth from '../hooks/useAuth';
import UserService from '../services/user.service';
import CalendarManagementService from '../services/calendar_management.service';
import GeneralSettingService from '../services/general_setting.service';
import { useTranslation } from 'react-i18next';
import { usePrompt } from '../hooks/usePrompt';
import { IconButton, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import AvailableSlotsService from '../services/available_slots.service';
import { bindEvent, getPusher, initPusher } from "../services/pusher.service";
import { hasAnyBookableSlot, toDisplayDateString, uniqueAvailabilityDates } from '../utils/availability';
import FlyproCardMetadata from './FlyproCardMetadata';

const EDIT_STEP_PATHS = [
  '/choose-location',
  '/choose-service',
  '/choose-therapist',
  '/payment'
];


const customStyles = {
  content: {
    width: "33%",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const customStyles2 = {
  content: {
    width: "33%",
    top: "50%",
    padding: "0px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    borderRadius: "0px",
    boxShadow: "none",
    maxWidth: "450px",
    margin: "auto",
    textAlign: "center",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    fontSize: 16
  },
};





Modal.setAppElement("#root");

function ChooseTherapist() {
  const { t, i18n } = useTranslation('therapist');

  // Helper function to get translation with fallback
  const getTranslation = (key, fallback) => {
    const translation = t(key);
    return translation === key ? fallback : translation;
  };
  const [selectedTherapist, setSelectedTherapist] = useState(() => {
    const state = JSON.parse(sessionStorage.getItem("state") || '{}');
    if (state?.selectedTherapist && Array.isArray(state.selectedTherapist)) {
      return state.selectedTherapist;
    }
    return state?.duo ? [] : [];
  });
  const [therapists, setTherapist] = useState([]);
  const [hours, setHours] = useState('');
  const [therapistsOther, setTherapistOther] = useState([]);
  const [currentTherapist, setCurrentTherapist] = useState('');
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalIsOpen2, setIsOpen2] = useState(false);
  const [selectedDateScroll, setSelectedDateScroll] = useState(new Date());
  const [previousSelection, setPreviousSelection] = useState({ date: null, time: null });
  const [selectedDate, setSelectedDate] = useState(() => {
    const saved = sessionStorage.getItem('state');
    const parsed = saved ? JSON.parse(saved) : {};
    // Try both selectedDate and date for compatibility
    return parsed.selectedDate
      ? new Date(parsed.selectedDate)
      : parsed.date
        ? new Date(parsed.date)
        : null;
  });

  const [selectedTime, setSelectedTime] = useState(() => {
    const saved = sessionStorage.getItem('state');
    const parsed = saved ? JSON.parse(saved) : {};
    return parsed.selectedTime || parsed.time || null;
  });

  useEffect(() => {
    if (!selectedTime && selectedTherapist.some(therapist => therapist?.id !== 0)) {
      setSelectedTherapist([{ id: 0 }]);
    }
  }, [selectedTime, selectedTherapist]);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [filter, setFilter] = useState(null)
  const [visibleDays, setVisibleDaysCount] = useState(10);

  const getInitialDaysToShow = () => {
    const maxVisibleMonths = 2;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endExclusive = new Date(today.getFullYear(), today.getMonth() + maxVisibleMonths + 1, 1);
    const days = [];
    let cur = new Date(today);
    while (cur < endExclusive) {
      days.push(new Date(cur.getFullYear(), cur.getMonth(), cur.getDate()));
      cur.setDate(cur.getDate() + 1);
    }
    return days.slice(0, 9);
  };
  const [daysToShow, setDaysToShow] = useState(() => getInitialDaysToShow());
  const updateDaysToShow = (baseDate) => {
    if (!baseDate || isNaN(baseDate.getTime())) {
      console.error('Invalid baseDate in updateDaysToShow');
      return;
    }

    const maxVisibleMonths = 2;
    const windowSize = 9;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const startAllowed = new Date(today);
    const endExclusive = new Date(today.getFullYear(), today.getMonth() + maxVisibleMonths + 1, 1);
    const allDays = [];
    let cur = new Date(startAllowed);
    while (cur < endExclusive) {
      allDays.push(new Date(cur.getFullYear(), cur.getMonth(), cur.getDate()));
      cur.setDate(cur.getDate() + 1);
    }

    const lastAllowedDate = allDays[allDays.length - 1];
    const anchor = new Date(baseDate);
    anchor.setHours(0, 0, 0, 0);
    if (anchor < allDays[0]) anchor.setTime(allDays[0].getTime());
    if (anchor > lastAllowedDate) anchor.setTime(lastAllowedDate.getTime());
    let startIndex = allDays.findIndex(d => d.getTime() >= anchor.getTime());
    if (startIndex === -1) startIndex = Math.max(0, allDays.length - windowSize);

    const maxStart = Math.max(0, allDays.length - windowSize);
    const clampedStart = Math.min(startIndex, maxStart);
    const slice = allDays.slice(clampedStart, clampedStart + windowSize);
    setDaysToShow(slice);
  };
  const [unavailableDates, setUnavailableDates] = useState([]);
  const [availableHours, setAvailableHours] = useState({});
  const [buffertime, setBufferTime] = useState([]);
  const [hasAutoSelected, setHasAutoSelected] = useState(false);

  const [filters, setFilters] = useState({
    with: 'primary_address,zones,media,categories,slots',
    sort: 'firstname'
  });

  // Ref guards to prevent multiple simultaneous API calls
  const isFetchingTherapists = useRef(false);
  const isFetchingAvailableHours = useRef(false);
  const isFetchingUnavailableDates = useRef(false);
  const unavailableDatesInFlightKeyRef = useRef(null);
  const unavailableDatesRequestRef = useRef(0);
  const availableHoursRequestRef = useRef(0);
  const availableHoursInFlightKeyRef = useRef(null);
  const availableHoursCacheRef = useRef(new Map());
  const [profileValidatingDateString, setProfileValidatingDateString] = useState(null);
  const isFetchingAllTherapists = useRef(false);
  const realtimeRefreshInFlightRef = useRef(false);
  const realtimeLastRefreshRef = useRef(0);
  const refreshAvailabilityRef = useRef(null);
  const [allTherapists, setAllTherapists] = useState([]);
  const location = useLocation();
  const { auth } = useAuth();
  const loc = useLocation();
  const [state, setState] = useState(loc.state || JSON.parse(sessionStorage.getItem('state') ?? '{}'));
  const {
    address = {},
    duo = false,
    selectedServices = [],
    phone = ''
  } = state || {};
  const { lng, lat, zip_code } = address || {};
  const notify = useNotifications();

  // Memoize derived values to prevent infinite loops
  const totalDuration = useMemo(() => {
    return selectedServices?.reduce((total, service, index) => {
      const duration = service?.product?.duration ? parseInt(service.product.duration, 10) : 0;
      return total + duration;
    }, 0) || 0;
  }, [selectedServices]);

  const totalPrice = useMemo(() => {
    return selectedServices?.reduce((total, service, index) => {
      const price = service?.product?.price ? service.product.price : 0;
      return total + price;
    }, 0) || 0;
  }, [selectedServices]);
  const navigate = useNavigate();
  const api = useApi();
  const [formData, setFormData] = useState({
    tags: "",
    is_asca: "",
    is_rme: "",
    civility: "",
    status: "ACTIVE"
  });

  // Memoize selectedServices to prevent infinite loops
  const memoizedSelectedServices = useMemo(() => {
    return selectedServices || [];
  }, [selectedServices]);

  // Synchronize hours state with availableHours from API
  useEffect(() => {
    if (availableHours && Array.isArray(availableHours) && availableHours.length > 0) {
      setHours(availableHours);
    } else if (availableHours && !Array.isArray(availableHours) && Object.keys(availableHours).length > 0) {
      // Handle object format from API
      const hoursArray = Object.keys(availableHours).filter(hour => availableHours[hour]);
      setHours(hoursArray);
    } else if (!availableHours || (Array.isArray(availableHours) && availableHours.length === 0) || (!Array.isArray(availableHours) && Object.keys(availableHours).length === 0)) {
      // Fallback to today's hours when no API data
      const todayHours = getNextHourSlots(new Date());
      setHours(todayHours);
    }
  }, [availableHours]);

  const [modalIsPaiementOpen, setModalIsPaiementOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState();

  const openModalPaiement = (message) => {
    setModalMessage(message);
    setModalIsPaiementOpen(true);
  };

  const closeModalPaiement = () => {
    setModalIsPaiementOpen(false);
  };

  const redirectToHome = () => {
    // si tu utilises react-router
    window.location.reload();
    setModalIsPaiementOpen(false);
  };


  const fetchCalendarTherapist = async (therapist, date) => {
    try {
      const response = await CalendarManagementService.index(
        {
          date: new Date(date).toLocaleDateString('en-CA').split('T')[0],
          therapist_id: therapist.id,
          with: 'therapist.media,therapist.zones,calendars_managements_slots.slot,therapist.categories',
        },
        api,
        auth?.accessToken ? false : true
      );
      return response



    } catch (error) {
      console.error('Erreur lors de la récupération des données du calendrier :', error);
      throw error;
    }
  };


  const isEditBookingMode = sessionStorage.getItem("editBookingMode") === "true" || (location?.state?.fromEditBooking);

  usePrompt(
    isEditBookingMode,
    "Êtes-vous sûr de vouloir quitter la modification ? Vos changements ne seront pas enregistrés.",
    next => EDIT_STEP_PATHS.some(p => next.pathname.startsWith(p))
  );


  function formatISODate(isoDate) {
    return new Date(isoDate).toLocaleDateString('en-CA').split("T")[0];
  }

  const addedTherapist = useCallback((therapist) => {
    if (!selectedDate || !selectedTime)
      return;
    setSelectedTherapist((prevTherapists) => {
      if (therapist.id === 0) {
        return [therapist];
      } else {
        const updatedTherapists = prevTherapists.some(t => t.id === 0) ? [] : prevTherapists;
        if (updatedTherapists.some(t => t.id === therapist.id)) {
          return updatedTherapists.filter(t => t.id !== therapist.id);
        } else if (!duo) {
          return [therapist];
        } else {
          if (updatedTherapists.length >= 2) {
            return updatedTherapists;
          }
          return [...updatedTherapists, therapist];
        }
      }
    });
  }, [selectedDate, selectedTime, duo]);
  useEffect(() => {
    const saved = sessionStorage.getItem('state');
    if (!saved) {
      if (therapists.length > 0 && !hasAutoSelected && selectedTherapist.length === 0) {
        setSelectedTherapist([{ id: 0 }]);
        setHasAutoSelected(true);
      }
      return;
    }

    const parsedState = JSON.parse(saved);

    // Check if we have preselected data (from edit redirect)
    const hasPreselectedTime = parsedState.selectedTime;
    const hasPreselectedTherapist = parsedState.selectedTherapist || parsedState.selectedTherapists;

    // If we have preselected data, don't auto-select "no preference"
    if (hasPreselectedTime && hasPreselectedTherapist) {
      return; // Exit early - don't auto-select
    }

    if (therapists.length > 0 && !hasAutoSelected && !hasPreselectedTherapist && selectedTherapist.length === 0) {
      setSelectedTherapist([{ id: 0 }]);
      setHasAutoSelected(true);
    }

    if (parsedState?.selectedTherapist) {
      setSelectedTherapist(parsedState.selectedTherapist);
      setHasAutoSelected(false);
    }
  }, [therapists, hasAutoSelected, selectedTherapist.length]);



  useEffect(() => {
    const saved = sessionStorage.getItem('state');
    if (!saved) return;
    const parsedState = JSON.parse(saved);
    setState(parsedState);

    // Set product IDs from session state if not already set
    if (Array.isArray(parsedState.selectedServices) && selectedProductIds.length === 0) {
      const productIds = parsedState.selectedServices.map(s => s?.product?.id).filter(Boolean);
      setSelectedProductIds(productIds);
    }

    // Set selectedDate and selectedTime from session state if not already set
    if (parsedState.selectedDate && (!selectedDate || selectedDate.toISOString().split('T')[0] !== new Date(parsedState.selectedDate).toISOString().split('T')[0])) {
      setSelectedDate(new Date(parsedState.selectedDate));
    }
    if (parsedState.selectedTime && !selectedTime) {
      setSelectedTime(parsedState.selectedTime);
    }
  }, []);


  // useEffect(() => {
  //   // Only run if all required data is present
  //   if (
  //     selectedProductIds.length > 0 &&
  //     selectedDate &&
  //     selectedTime &&
  //     therapists.length === 0 && // Only fetch if not already fetched
  //     !isFetchingTherapists.current // Prevent multiple simultaneous calls
  //   ) {
  //     const fetchFromSession = async () => {
  //       if (isFetchingTherapists.current) {
  //         return;
  //       }

  //       isFetchingTherapists.current = true;

  //       const saved = sessionStorage.getItem('state');
  //       const parsedState = saved ? JSON.parse(saved) : {};
  //       const dateStr = parsedState.selectedDate || (selectedDate && selectedDate.toISOString().split('T')[0]);
  //       const timeStr = parsedState.selectedTime || selectedTime;
  //       const durationVal = totalDuration;
  //       const lngVal = parsedState.address?.lng || lng;
  //       const latVal = parsedState.address?.lat || lat;
  //       const zipVal = parsedState.address?.zip_code || zip_code;
  //       const isDuo = parsedState.duo || duo;
  //       const productsVal = parsedState.selectedServices ? parsedState.selectedServices.map(s => s?.product?.id).filter(Boolean) : selectedProductIds;

  //       try {
  //         const isEditMode = sessionStorage.getItem("editBookingMode") === "true";
  //         const booking = JSON.parse(sessionStorage.getItem("newBooking"));
  //         const oldBooking = JSON.parse(sessionStorage.getItem("oldBooking"));
  //         let [therapistResponse] = await Promise.all([
  //           TherapistService.store(
  //             isEditMode ? {
  //               date: dateStr,
  //               time: timeStr,
  //               duration: durationVal,
  //               lng: lngVal,
  //               lat: latVal,
  //               zip_code: zipVal,
  //               products: productsVal,
  //               is_duo: isDuo,
  //               status: "ACTIVE",
  //               booking_id: booking?.id ?? oldBooking?.id ?? 0
  //             } : {
  //               date: dateStr,
  //               time: timeStr,
  //               duration: durationVal,
  //               lng: lngVal,
  //               lat: latVal,
  //               zip_code: zipVal,
  //               products: productsVal,
  //               is_duo: isDuo,
  //               status: "ACTIVE",
  //             },
  //             api,
  //             {
  //               with: `media,ratings,ratings.creator.media,categories`,
  //               ...formData
  //             }
  //           ),
  //         ]);

  //         let processedTherapists = therapistResponse;
  //         if (isDuo) {
  //           const flattened = [].concat(...Object.values(therapistResponse));
  //           processedTherapists = Array.from(
  //             new Map(flattened.map(t => [t.id, t])).values()
  //           );
  //         }

  //         if (!processedTherapists || processedTherapists.length === 0) {
  //           try {
  //             const allTherapistsRaw = await UserService.indexByRole(
  //               { ...filters, status: "ACTIVE" },
  //               'ROLE_FLYPRO',
  //               api,
  //               true
  //             );
  //             const allTherapists = allTherapistsRaw.sort((a, b) => {
  //               return (a.agent_type === "EMPLOYEE" ? -1 : 1) - (b.agent_type === "EMPLOYEE" ? -1 : 1);
  //             });
  //             processedTherapists = allTherapists || [];
  //           } catch (error) {
  //             console.error('Error fetching all therapists:', error);
  //             processedTherapists = [];
  //           }
  //         }
  //               console.log({custom_log_2: processedTherapists});

  //         setTherapist(processedTherapists);

  //         // After therapists are fetched, set selectedTherapist from session if present and not already set
  //         if (
  //           Array.isArray(parsedState.selectedTherapists) &&
  //           (!selectedTherapist || selectedTherapist.length === 0)
  //         ) {
  //           setSelectedTherapist(parsedState.selectedTherapists);
  //           setHasAutoSelected(true);
  //         } else if (
  //           Array.isArray(parsedState.selectedTherapist) &&
  //           (!selectedTherapist || selectedTherapist.length === 0)
  //         ) {
  //           setSelectedTherapist(parsedState.selectedTherapist);
  //           setHasAutoSelected(true);
  //         } else if (
  //           processedTherapists.length > 0 &&
  //           !hasAutoSelected &&
  //           (!selectedTherapist || selectedTherapist.length === 0) &&
  //           !parsedState.selectedTherapist &&
  //           !parsedState.selectedTherapists
  //         ) {
  //           setSelectedTherapist([{ id: 0 }]);
  //           setHasAutoSelected(true);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching therapists after redirect:", error);
  //       } finally {
  //         isFetchingTherapists.current = false;
  //       }
  //     };
  //     fetchFromSession();
  //   }
  //   // Only run when all required data is available and therapists are not yet fetched
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [selectedProductIds, selectedDate, selectedTime]);


  useEffect(() => {
    const saved = sessionStorage.getItem('state');
    const parsedState = saved ? JSON.parse(saved) : {};
    const rawSelectedServices = parsedState.selectedServices || [];
    const normalizedServices = Array.isArray(rawSelectedServices)
      ? rawSelectedServices.map(s => s && s.product ? s : { product: s })
      : [];
    const address = parsedState.address;

    if (!normalizedServices || normalizedServices.length === 0) {
      navigate('/choose-service');
    } else if (!address) {
      navigate('/choose-address');
    }
  }, [navigate]);



  useEffect(() => {
    // const now = new Date();
    // let timeToUse = selectedTime;
    // if (!selectedTime) {
    //   const nextQuarterHour = Math.ceil(now.getMinutes() / 15) * 15;
    //   now.setMinutes(nextQuarterHour);
    //   now.setSeconds(0);
    //   timeToUse = now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    // }

    let timeToUse = selectedTime;
    let dateToUse = selectedDate;

    if (!timeToUse) {
      const now = new Date();
      const zurichNow = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Zurich" }));
      const minutes = zurichNow.getMinutes();
      const nextQuarter = Math.ceil(minutes / 15) * 15;

      if (nextQuarter === 60) {
        zurichNow.setHours(zurichNow.getHours() + 1);
        zurichNow.setMinutes(0);
      } else {
        zurichNow.setMinutes(nextQuarter);
      }
      zurichNow.setSeconds(0);
      zurichNow.setMilliseconds(0);

      timeToUse = zurichNow.toTimeString().slice(0, 5);
    }

    if (!dateToUse) {
      const now = new Date();
      const zurichDateStr = now.toLocaleString("en-US", { timeZone: "Europe/Zurich" });
      const zurichDate = new Date(zurichDateStr);
      zurichDate.setHours(0, 0, 0, 0);
      dateToUse = zurichDate;
    }

    // Always show therapists by zone and service on initial load (no selected time)
    if (selectedDate && !selectedTime) {
      handleIfInvalidOrPastDate(dateToUse, null);
    }
    // Show therapists for specific time slot when time is selected
    if (selectedDate && selectedTime) {
      fetchTherapist(formatISODate(dateToUse), timeToUse, totalDuration, lng, lat, zip_code);
    }
    else {
      handleIfInvalidOrPastDate((dateToUse), null)
    }

    // fetchUnavailableDates();
    fetchBufferTime();
    // fetchAvailableHours();
    if (selectedDate || selectedDateScroll) {
      updateDaysToShow(selectedDate || selectedDateScroll);
    }
  }, [selectedDate, selectedTime, totalDuration, lng, lat, zip_code, visibleDays, selectedDateScroll]);

  // Set today's date as default if no date is selected
  // useEffect(() => {
  //   if (!selectedDate) {
  //     setSelectedDate(new Date());
  //   }
  // }, []);

  // Separate effect to fetch available hours when date is selected
  useEffect(() => {
    if (selectedDate && selectedProductIds.length && zip_code && lat && lng) {
      fetchAvailableHours();
    }
  }, [selectedDate, selectedProductIds, zip_code, lat, lng, totalDuration, modalIsOpen2, currentTherapist?.id]);

  useEffect(() => {
    if (!modalIsOpen2 || !selectedDate || !availableHours) {
      return;
    }

    if (profileValidatingDateString === selectedDate.toDateString()) {
      return;
    }

    const selectedDateString = selectedDate.toDateString();
    const hasBookableHour = hasAnyBookableSlot(availableHours);

    setUnavailableDates((previousDates) => {
      const dateExists = previousDates.includes(selectedDateString);
      if (hasBookableHour && !dateExists) {
        return [...previousDates, selectedDateString];
      }
      if (!hasBookableHour && dateExists) {
        return previousDates.filter((date) => date !== selectedDateString);
      }
      return previousDates;
    });
  }, [availableHours, modalIsOpen2, profileValidatingDateString, selectedDate]);


  const fetchUnavailableDates = async () => {
    // console.log({selectedDate, selectedDateScroll})
    if (modalIsOpen2 && !currentTherapist?.id) {
      return;
    }

    let didStartRequest = false;

    try {
      const startBase = (daysToShow && daysToShow.length)
        ? daysToShow[0]
        : (selectedDateScroll || selectedDate || new Date());
      const startDate = startBase.toLocaleDateString('en-CA').split('T')[0];
      const endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + visibleDays + 1);
      const formattedEndDate = endDate.toLocaleDateString('en-CA').split('T')[0];

      let dates = [];
      const therapistForCalendar = modalIsOpen2 ? currentTherapist : null;
      const requestKey = [
        startDate,
        formattedEndDate,
        therapistForCalendar?.id || '',
        modalIsOpen2 ? 'profile' : 'list',
      ].join('|');

      if (isFetchingUnavailableDates.current && unavailableDatesInFlightKeyRef.current === requestKey) {
        return;
      }

      isFetchingUnavailableDates.current = true;
      unavailableDatesInFlightKeyRef.current = requestKey;
      didStartRequest = true;

      if((selectedDate || selectedTime) && !modalIsOpen2){
        setPreviousSelection({ date: selectedDate, time: selectedTime });
      }
      const requestId = ++unavailableDatesRequestRef.current;

      dates = await fetchCalendarData(startDate, formattedEndDate, therapistForCalendar);

      if (requestId === unavailableDatesRequestRef.current) {
        let formattedDates = dates.map(toDisplayDateString).filter(Boolean);
        if (modalIsOpen2 && selectedDate && availableHours && Object.keys(availableHours).length > 0) {
          const selectedDateString = selectedDate.toDateString();
          const hasBookableHour = hasAnyBookableSlot(availableHours);
          formattedDates = hasBookableHour
            ? Array.from(new Set([...formattedDates, selectedDateString]))
            : formattedDates.filter((date) => date !== selectedDateString);
        }
        setUnavailableDates(formattedDates);
      }
    } catch (error) {
      console.error('Error fetching unavailable dates:', error);
    } finally {
      if (didStartRequest) {
        isFetchingUnavailableDates.current = false;
        unavailableDatesInFlightKeyRef.current = null;
      }
    }

  };

  useEffect(() => {
    fetchUnavailableDates();
  }, [daysToShow, selectedDate, visibleDays, selectedDateScroll, selectedTime, modalIsOpen2, currentTherapist?.id]);

  const fetchCalendarEntries = useCallback(async (start, end, therapist = null) => {
    try {
      const params = {
        with: 'therapist.media,therapist.zones,calendars_managements_slots.slot,therapist.categories',
        date: `between:${start},${end}`,
      };
  
      if (therapist?.id) {
        params.therapist_id = therapist.id;
      }
  
      return await CalendarManagementService.index(
        params,
        api,
        auth?.accessToken ? false : true
      );
    } catch (error) {
      console.error('Erreur lors de la récupération des données du calendrier :', error);
      throw error;
    }
  }, [api, auth?.accessToken]);

  const fetchCalendarData = useCallback(async (start, end, therapist = null) => {
    try {
      const response = await fetchCalendarEntries(start, end, therapist);
      const filteredDates = [];
      response.forEach(entry => {
        if (entry.date && entry.calendars_managements_slots.length > 0 && entry.calendars_managements_slots.some(slot => slot.status === 'AVAILABLE' || slot.status === 'OVER_TIME')) {
          filteredDates.push(entry.date);
        }
      });
      // console.log('filteredDates', filteredDates);


      return uniqueAvailabilityDates(filteredDates);

    } catch (error) {
      console.error('Erreur lors de la récupération des données du calendrier :', error);
      throw error;
    }
  }, [fetchCalendarEntries]);

  const fetchBufferTime = async () => {
    try {
      const bufferTime = await GeneralSettingService.index('setting=in:buffer_before,buffer_after', api, auth?.accessToken ? false : true);

      const bufferBefore = bufferTime.find(item => item.setting === 'buffer_before')?.value || '0';
      const bufferAfter = bufferTime.find(item => item.setting === 'buffer_after')?.value || '0';

      setBufferTime({ bufferBefore, bufferAfter });
      // console.log('Buffer:', buffertime);
    } catch (error) {
      console.error('Error fetching buffer time:', error);
    }
  };

  const fetchAvailableHours = async () => {
    const dateToUse = selectedDate ? new Date(selectedDate) : new Date();
    const isProfileMode = Boolean(modalIsOpen2 && currentTherapist?.id);

    if (!selectedDate || !selectedProductIds.length || !zip_code || !lat || !lng) {
      setAvailableHours({});
      if (isProfileMode) {
        setProfileValidatingDateString(null);
      }
      return;
    }

    const isEditMode = sessionStorage.getItem("editBookingMode") === "true";
    const booking = JSON.parse(sessionStorage.getItem("newBooking"));
    const oldBooking = JSON.parse(sessionStorage.getItem("oldBooking"));
    const date = new Date(dateToUse).toLocaleDateString('en-CA').split('T')[0];
    const params = {
      date,
      duration: totalDuration,
      lng,
      lat,
      zip_code,
      products: selectedProductIds,
      is_hotel: false,
      is_duo: duo,
    };

    if (isEditMode) {
      params.booking_id = booking?.id ?? oldBooking?.id ?? 0;
    }

    if (isProfileMode) {
      params.therapists = [currentTherapist.id];
      params.is_duo = false;
    }

    const requestKey = JSON.stringify({
      date: params.date,
      duration: params.duration,
      lng: params.lng,
      lat: params.lat,
      zip_code: params.zip_code,
      products: params.products,
      is_duo: params.is_duo,
      booking_id: params.booking_id || null,
      therapists: params.therapists || null,
    });

    if (isProfileMode) {
      const selectedDateString = selectedDate.toDateString();
      setProfileValidatingDateString(selectedDateString);

      if (availableHoursCacheRef.current.has(requestKey)) {
        setAvailableHours(availableHoursCacheRef.current.get(requestKey));
        setProfileValidatingDateString(null);
        return;
      }

      if (availableHoursInFlightKeyRef.current === requestKey) {
        return;
      }
    }

    const requestId = ++availableHoursRequestRef.current;
    if (isProfileMode) {
      availableHoursInFlightKeyRef.current = requestKey;
    }

    try {
      const availabilities = await AvailableSlotsService.store(params, api);

      if (requestId !== availableHoursRequestRef.current) {
        return;
      }

      if (isProfileMode) {
        availableHoursCacheRef.current.set(requestKey, availabilities);
      }

      setAvailableHours(availabilities);
    } catch (error) {
      if (requestId === availableHoursRequestRef.current) {
        setAvailableHours({});
      }
    } finally {
      if (isProfileMode && availableHoursInFlightKeyRef.current === requestKey) {
        availableHoursInFlightKeyRef.current = null;
        setProfileValidatingDateString(null);
      }
    }
  };

  const handleIfInvalidOrPastDate = async (date, time) => {
    const selectedCategoryIds = selectedServices.map(service => service.category?.id).filter(Boolean);
    const today = new Date();
    const selected = new Date(date);

    const noRealDate =
      !date ||
      date === '1970-01-01' ||
      isNaN(selected.getTime()) ||
      selected < new Date(today.toDateString());

    // Show therapists by zone and service for initial load or invalid dates
    if (noRealDate || !time) {
      isFetchingAllTherapists.current = true;
      try {
        // Use allTherapists instead of fetching again
        const allTherapistsRaw = allTherapists.length > 0 ? allTherapists : await UserService.indexByRole(
          { ...filters, status: "ACTIVE" },
          'ROLE_FLYPRO',
          api,
          true
        );
        setAllTherapists(allTherapistsRaw);

        const therapistsToUse = allTherapistsRaw.sort((a, b) => {
          return (a.agent_type === "EMPLOYEE" ? -1 : 1) - (b.agent_type === "EMPLOYEE" ? -1 : 1);
        });

        // Filter therapists by zone
        const therapistsInZone = zip_code
          ? therapistsToUse.filter(therapist =>
            therapist.zones?.some(zone => {
              const zipParts = zone.zip_code.split(",");
              return zipParts.some(part => {
                const zipRange = part.split("-").map(Number);
                if (zipRange.length === 1) {
                  return zip_code == zipRange[0];
                } else {
                  const [startZip, endZip] = zipRange;
                  return zip_code >= startZip && zip_code <= endZip;
                }
              });
            })
          )
          : therapistsToUse;

        const filteredTherapists = selectedCategoryIds.length > 0
          ? therapistsInZone.filter(therapist =>
            therapist.categories?.some(cat => selectedCategoryIds.includes(cat.id))
          )
          : therapistsInZone;
        setTherapist(filteredTherapists);
        setTherapistOther([]); // No "available on other slots" for initial load

        if (
          filteredTherapists.length > 0 &&
          (!selectedTherapist || selectedTherapist.length === 0) &&
          !hasAutoSelected
        ) {
          setTimeout(() => {
            setSelectedTherapist([{ id: 0 }]);
            setHasAutoSelected(true);
          }, 100);
        }

        return true; // pour indiquer que la date était invalide
      } catch (error) {
        setTherapist([]);
        setTherapistOther([]);
        return true;
      } finally {
        isFetchingAllTherapists.current = false;
      }
    }

    return false; // la date est valide
  };

  useEffect(() => {
    if (allTherapists.length > 0 || isFetchingAllTherapists.current) {
      return;
    }

    const fetchAllTherapists = async () => {
      isFetchingAllTherapists.current = true;
      try {
        const therapistsRaw = await UserService.indexByRole(
          { ...filters, status: "ACTIVE" },
          'ROLE_FLYPRO',
          api,
          true
        );
        // const sorted = therapistsRaw.sort((a, b) => {
        //   return (a.agent_type === "EMPLOYEE" ? -1 : 1) - (b.agent_type === "EMPLOYEE" ? -1 : 1);
        // });
        setAllTherapists(therapistsRaw);
      } catch (error) {
        console.error('Error fetching all therapists:', error);
        setAllTherapists([]);
      } finally {
        isFetchingAllTherapists.current = false;
      }
    };

    fetchAllTherapists();
  }, [api, filters]);

  const fetchTherapist = async (
    date,
    time,
    duration,
    longitude,
    latitude,
    zip_code,
    filtredData
  ) => {

    if (!selectedProductIds.length) return;

    try {

      const isEditMode = sessionStorage.getItem("editBookingMode") === "true";
      const booking = JSON.parse(sessionStorage.getItem("newBooking"));
      const oldBooking = JSON.parse(sessionStorage.getItem("oldBooking"));
      // Si la date est valide et future ou aujourd'hui, on continue normalement
      // Note: hours will be set by availableHours from API
      let [therapistResponse, allTherapistsRaw] = await Promise.all([
        TherapistService.store(
          isEditMode ? {
            date,
            time,
            duration,
            lng: longitude,
            lat: latitude,
            zip_code,
            products: selectedProductIds,
            is_duo: duo,
            status: "ACTIVE",
            booking_id: booking?.id ?? oldBooking?.id ?? 0
          } : {
            date,
            time,
            duration,
            lng: longitude,
            lat: latitude,
            zip_code,
            products: selectedProductIds,
            is_duo: duo,
            status: "ACTIVE",
          },
          api,
          { with: `media,categories`, ...formData }
        ),
        // Use cached allTherapists or fetch if empty
        allTherapists.length > 0 ? Promise.resolve(allTherapists) : UserService.indexByRole(
          { ...filters, status: "ACTIVE" },
          'ROLE_FLYPRO',
          api,
          true
        )
      ]);

      const therapistsToUse = allTherapistsRaw.sort((a, b) => {
        return (a.agent_type === "EMPLOYEE" ? -1 : 1) - (b.agent_type === "EMPLOYEE" ? -1 : 1);
      });

      // console.log('log for fetchflypro', therapistResponse,allTherapists )


      if (duo) {
        const flattened = [].concat(...Object.values(therapistResponse));
        therapistResponse = Array.from(
          new Map(flattened.map(t => [t.id, t])).values()
        );
      }

      setTherapist(therapistResponse || []);

      if (
        (therapistResponse || []).length > 0 &&
        (!selectedTherapist || selectedTherapist.length === 0) &&
        !hasAutoSelected
      ) {
        setTimeout(() => {
          setSelectedTherapist([{ id: 0 }]);
          setHasAutoSelected(true);
        }, 100);
      }

      // Filter by zone and service categories for "available on other slots"
      const selectedCategoryIds = selectedServices.map(service => service.category?.id).filter(Boolean);
      const therapistIds = new Set((therapistResponse || []).map(t => t.id));
      // Filter out therapists that are already available at this time slot
      const remainingTherapists = therapistsToUse.filter(therapist => !therapistIds.has(therapist.id));

      // Filter therapists by zone
      const therapistsInZone = zip_code
        ? therapistsToUse.filter(therapist => {
          if (therapistIds.has(therapist.id)) return false;

          if (!therapist.zones || therapist.zones.length === 0) {
            return false;
          }

          const inZone = therapist.zones.some(zone => {
            if (!zone.zip_code) {
              return false;
            }

            const zipParts = zone.zip_code.split(",");

            return zipParts.some(part => {
              const zipRange = part.split("-").map(Number);
              if (zipRange.length === 1) {
                return zip_code == zipRange[0];
              } else {
                const [startZip, endZip] = zipRange;
                return zip_code >= startZip && zip_code <= endZip;
              }
            });
          });

          return inZone;
        })
        : therapistsToUse.filter(t => !therapistIds.has(t.id));

      // Filter by service categories
      const filteredTherapists = selectedCategoryIds.length > 0
        ? therapistsInZone.filter(therapist =>
          therapist.categories?.some(cat => selectedCategoryIds.includes(cat.id))
        )
        : therapistsInZone;


      setTherapistOther(filteredTherapists);
    } catch (error) {
      setTherapist([]);
      setTherapistOther([]);
    }
  };

  const refreshAvailability = useCallback(async () => {
    if (modalIsOpen2) {
      return;
    }

    if (realtimeRefreshInFlightRef.current) {
      return;
    }

    const now = Date.now();
    if (now - realtimeLastRefreshRef.current < 1500) {
      return;
    }

    realtimeLastRefreshRef.current = now;
    realtimeRefreshInFlightRef.current = true;

    try {
      const dateToUse = selectedDate ? new Date(selectedDate) : null;
      const hasValidDate = dateToUse && !isNaN(dateToUse.getTime());

      if (hasValidDate && selectedTime) {
        await fetchTherapist(
          formatISODate(dateToUse),
          selectedTime,
          totalDuration,
          lng,
          lat,
          zip_code
        );
      } else if (hasValidDate) {
        await handleIfInvalidOrPastDate(dateToUse, null);
      }

      await fetchAvailableHours();
      await fetchUnavailableDates();
    } catch (error) {
      console.error("Realtime availability refresh failed:", error);
    } finally {
      realtimeRefreshInFlightRef.current = false;
    }
  }, [
    selectedDate,
    selectedTime,
    totalDuration,
    lng,
    lat,
    zip_code,
    fetchTherapist,
    fetchAvailableHours,
    fetchUnavailableDates,
    handleIfInvalidOrPastDate,
    modalIsOpen2,
  ]);

  useEffect(() => {
    refreshAvailabilityRef.current = refreshAvailability;
  }, [refreshAvailability]);

  useEffect(() => {
    initPusher({ token: auth?.accessToken });

    const handler = (data) => {
      const payload =
        typeof data === "string"
          ? (() => {
              try {
                return JSON.parse(data);
              } catch (_) {
                return {};
              }
            })()
          : data || {};

      const key = payload?.key;
      if (key !== "availability" && key !== "calendar") {
        return;
      }

      refreshAvailabilityRef.current?.();
    };

    const unbind = bindEvent("public-data", "realtime.data.updated", handler);

    return () => {
      unbind();
    };
  }, [auth?.accessToken]);

  useEffect(() => {
    initPusher({ token: auth?.accessToken });
    const pusher = getPusher();
    if (!pusher) return;

    const handleConnected = () => {
      refreshAvailabilityRef.current?.();
    };

    pusher.connection.bind("connected", handleConnected);

    return () => {
      pusher.connection.unbind("connected", handleConnected);
    };
  }, [auth?.accessToken]);

  useEffect(() => {
    const handleOnline = () => {
      refreshAvailabilityRef.current?.();
    };

    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  const fetchTherapistWithRatings = async (therapistId) => {
    const res = await UserService.indexByRole(
      {
        id: therapistId,
        with: 'media,categories,ratings,ratings.creator.media',
      },
      'ROLE_FLYPRO',
      api,
      true
    );

    return Array.isArray(res) ? res[0] : res;
  };

  const openModal = () => setIsOpen(true);
  const openModal2 = async (therapist) => {
    const profileDate = selectedDate || selectedDateScroll || (daysToShow && daysToShow.length ? daysToShow[0] : new Date());
    const normalizedProfileDate = new Date(profileDate);
    normalizedProfileDate.setHours(0, 0, 0, 0);

    unavailableDatesRequestRef.current += 1;
    availableHoursRequestRef.current += 1;
    availableHoursInFlightKeyRef.current = null;
    setPreviousSelection({ date: selectedDate, time: selectedTime });
    setUnavailableDates([]);
    setAvailableHours({});
    setSelectedDate(normalizedProfileDate);
    setSelectedDateScroll(normalizedProfileDate);
    setProfileValidatingDateString(normalizedProfileDate.toDateString());
    setSelectedTime(null);
    setCurrentTherapist(therapist);
    setIsOpen2(true);
    try {
      const full = await fetchTherapistWithRatings(therapist.id);
      if (full) setCurrentTherapist(full);
    } catch (e) {
      console.error("Failed to load therapist ratings:", e);
    }
  };

  const closeModal = () => setIsOpen(false);
  const closeModal2 = () => {
    setIsOpen2(false);
    setProfileValidatingDateString(null);
    availableHoursInFlightKeyRef.current = null;
    setSelectedTherapist([{ id: 0 }]);
  
    if (previousSelection.date) {
      setSelectedDate(previousSelection.date);
    }
    if (previousSelection.time) {
      setSelectedTime(previousSelection.time);
    }
  };
  
  const handleSubmit = async (event) => {
    event?.preventDefault();

    if(selectedDate && selectedTime && modalIsOpen2 && currentTherapist){
      setSelectedTherapist([currentTherapist]);
    }

    const isEditingSequential = sessionStorage.getItem("editingSequential") === "true";

    if (isEditingSequential) {
      // For sequential bookings, only allow 1 therapist
      if (selectedTherapist.length !== 1) {
        notify.warn(getTranslation('pleaseSelectFlypro', 'Please select a therapist'));
        return;
      }

      const noPreferences = selectedTherapist.length === 1 && selectedTherapist[0].id === 0;

      const paymentState = {
        address,
        duo: false, // Sequential is not DUO
        no_preferences: noPreferences,
        phone,
        totalDuration,
        totalPrice,
        selectedServices,
        selectedTherapist: selectedTherapist, // Only 1 therapist
        selectedDate: selectedDate.toLocaleDateString('en-CA'),
        selectedTime
      };

      navigate('/payment', { state: paymentState });
      return;
    }
    let therapistBlocked = false;

    const selectedTherapists = selectedTherapist[0]?.id === 0
      ? (duo && therapists.length >= 2 ? [therapists[0], therapists[1]]
        : !duo && therapists.length >= 1 ? [therapists[0]] : [{ id: 0 }])
      : selectedTherapist;

    if (duo && selectedTherapists.length !== 2) {
      notify.warn(getTranslation('please_select_two_flypros_for_duo', 'Please select two therapists for duo'));
      return;
    } else if (!duo && selectedTherapists.length !== 1) {
      notify.warn(getTranslation('pleaseSelectFlypro', 'Please select a therapist'));
      return;
    }

    const noPreferences = selectedTherapist.length === 1 && selectedTherapist[0].id === 0;

    await fetchTherapist(formatISODate(selectedDate), selectedTime, totalDuration, lng, lat, zip_code);
    const therapistIds = new Set(therapists.map(o => o.id));
    const selectedTherapistIds = selectedTherapists.map(o => o.id);

    if (!selectedTherapistIds.every(id =>
      therapistIds.has(id))) {
      openModalPaiement(getTranslation('unavailable_therapist', 'Therapist unavailable'));
      therapistBlocked = true;
    }
    if (therapistBlocked) {
      return;
    }

    const paymentState = {
      address,
      duo,
      no_preferences: noPreferences,
      phone,
      totalDuration,
      totalPrice,
      selectedServices,
      selectedTherapist: selectedTherapists,
      selectedDate: selectedDate.toLocaleDateString('en-CA'),
      selectedTime
    };

    const prevState = JSON.parse(sessionStorage.getItem('state') || '{}');
    sessionStorage.setItem('state', JSON.stringify({ ...prevState, ...paymentState }));

    // Si en mode édition
    const isEditMode = sessionStorage.getItem("editBookingMode") === "true";
    if (isEditMode) {
      const existingNew = sessionStorage.getItem("newBooking");
      const parsedNew = existingNew ? JSON.parse(existingNew) : {};

      const mergedNew = {
        ...parsedNew,
        date: selectedDate.toISOString().split("T")[0],
        time: selectedTime,
        therapist: duo ? selectedTherapists : selectedTherapists[0],
        therapists: selectedTherapists,
        duo: duo,
      };

      sessionStorage.setItem("newBooking", JSON.stringify(mergedNew));
    }

    const hasMatchingId = therapists.some(therapist =>
      selectedTherapists.some(selected => selected.id === therapist.id)
    );

    if (!auth || Object.keys(auth).length === 0) {
      sessionStorage.setItem('redirectAfterLogin', '/payment');
      sessionStorage.setItem('paymentState', paymentState);
      // navigate('/login');
      // return;
    }

    if (hasMatchingId)
      navigate('/payment', { state: paymentState });
    else
      navigate('/flypro-booking', { state: paymentState });
  };




  const handleSubmitFilter = (event) => {
    event.preventDefault();
    setFilter(formData);
    setTimeout(async () => {
      handleHourClick(selectedTime);
      if (selectedDate && selectedTime) {
        await fetchTherapist(
          formatISODate(selectedDate),
          selectedTime,
          totalDuration,
          lng,
          lat,
          zip_code
        );
      }
    }, 1000);

    closeModal();
  };


  const handleMonthChange = (direction) => {
    const now = Date.now();
    if (window.lastMonthChange && (now - window.lastMonthChange) < 300) return;
    window.lastMonthChange = now;

    const currentDate = selectedDate || selectedDateScroll;
    if (!currentDate || isNaN(currentDate.getTime())) {
      console.error('Invalid date in handleMonthChange');
      return;
    }


    const maxVisibleMonths = 2;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const firstAllowedMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastAllowedMonth = new Date(today.getFullYear(), today.getMonth() + maxVisibleMonths, 1);

    const newDate = new Date(currentDate);
    newDate.setDate(1);
    newDate.setMonth(newDate.getMonth() + direction);
    newDate.setHours(0, 0, 0, 0);
    if (newDate < firstAllowedMonth) return;
    if (newDate > lastAllowedMonth) return;
    if (newDate.getFullYear() === today.getFullYear() && newDate.getMonth() === today.getMonth()) {
      newDate.setDate(today.getDate());
    } else {

      newDate.setDate(1);
    }


    const lastAllowedDate = new Date(today.getFullYear(), today.getMonth() + maxVisibleMonths + 1, 0);
    if (newDate > lastAllowedDate) newDate.setTime(lastAllowedDate.getTime());

    if (selectedDate) setSelectedDate(newDate);
    setSelectedDateScroll(newDate);
    updateDaysToShow(newDate);
    setSelectedTherapist([{ id: 0 }]);
  };

  const handleDayChange = (direction) => {
    const now = Date.now();
    if (window.lastDayChange && (now - window.lastDayChange) < 200) return;
    window.lastDayChange = now;

    const currentDate = selectedDate || selectedDateScroll;
    if (!currentDate || isNaN(currentDate.getTime())) {
      console.error('Invalid date in handleDayChange');
      return;
    }

    const container = document.querySelector('.row-date');
    if (!container) return;

    const dayElement = container.querySelector('.btn-day');
    const dayWidth = dayElement ? (dayElement.offsetWidth || 0) : 0;
    const containerWidth = container.clientWidth || 0;
    let visibleItems = 1;
    if (dayWidth > 0) {
      visibleItems = Math.max(1, Math.floor(containerWidth / dayWidth));
    }
    const daysToScroll = Math.max(1, Math.floor(visibleItems - 0.5));
  const maxVisibleMonths = 2;
  const windowSize = 9;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const endExclusive = new Date(today.getFullYear(), today.getMonth() + maxVisibleMonths + 1, 1);
  const allDays = [];
  let cur = new Date(today);
  while (cur < endExclusive) {
    allDays.push(new Date(cur.getFullYear(), cur.getMonth(), cur.getDate()));
    cur.setDate(cur.getDate() + 1);
  }

  const firstVisible = daysToShow && daysToShow.length ? daysToShow[0] : (selectedDate || today);
  let currentStartIndex = allDays.findIndex(d => d.getTime() === new Date(firstVisible.getFullYear(), firstVisible.getMonth(), firstVisible.getDate()).getTime());
  if (currentStartIndex === -1) {
    currentStartIndex = allDays.findIndex(d => d.getTime() >= (new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()).getTime()));
    if (currentStartIndex === -1) currentStartIndex = Math.max(0, allDays.length - windowSize);
  }

  const maxStart = Math.max(0, allDays.length - windowSize);
  let newStart = currentStartIndex + direction * daysToScroll;
  if (newStart < 0) newStart = 0;
  if (newStart > maxStart) newStart = maxStart;

  const newWindow = allDays.slice(newStart, newStart + windowSize);
  setDaysToShow(newWindow);
  const newSelected = newWindow.length ? newWindow[0] : (allDays[allDays.length - 1] || today);
  if (selectedDate) setSelectedDate(newSelected);
  setSelectedDateScroll(newSelected);
  setSelectedTime(null);
  setTherapist([]);
  setSelectedTherapist([{ id: 0 }]);
    if (selectedTime === null)
      return;
    //fetchTherapist(formatISODate(newDate), selectedTime, totalDuration, lat, lng, zip_code);

  };
  const redirectToPartnerHotels = () => {
    window.location.href = '/hotels';
  };

  function handleDayClick(date) {
    setSelectedDate(date);
    setSelectedTime(null)
    setSelectedTherapist([{ id: 0 }]);
    setTherapist([])
    const now = new Date();
    let initialTime;
    if (date.getDay() === 0) {
      setShowPopup(true);
    }


    if (selectedTime === null)
      return;

    if (date?.toDateString() === now?.toDateString()) {
      const nextQuarterHour = Math.ceil(now.getMinutes() / 15) * 15;
      now.setMinutes(nextQuarterHour);
      now.setSeconds(0);

      initialTime = now;
    } else {
      initialTime = new Date(date);
      initialTime.setHours(8, 0, 0, 0);
    }

    //setSelectedTime(initialTime.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }));
    //fetchTherapist(formatISODate(date), selectedTime, totalDuration, lat, lng, zip_code);
  }


  function handleHourClick(hour) {
    let dateToUse = selectedDate;

    if (!selectedDate) {
      dateToUse = new Date();
      setSelectedDate(dateToUse);
    }

    setSelectedTime(hour);
    if(selectedDate && modalIsOpen2 && currentTherapist){
      setSelectedTherapist([currentTherapist]);
    }else {
      setSelectedTherapist([{ id: 0 }]);
    }
    // fetchTherapist(formatISODate(dateToUse), hour, totalDuration, lng, lat, zip_code);
  }



  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox"
        ? prevState[name] === value
          ? "" // Uncheck si déjà sélectionné
          : value
        : value,
    }));
  };

  const handleResetFilter = async () => {
    const resetFormData = {
      tags: "",
      is_asca: "",
      is_rme: "",
      civility: "",
      status: "ACTIVE"
    };

    const resetFilters = {
      with: 'primary_address,zones,media,categories,slots',
      sort: 'firstname'
    };

    setFormData(resetFormData);
    setFilters(resetFilters);
    setFilter(null);

    try {
      const date = formatISODate(selectedDate);
      const time = selectedTime;
      const duration = totalDuration;
      const longitude = lng;
      const latitude = lat;
      const zipCode = zip_code;
      const products = selectedProductIds;
      const isEditMode = sessionStorage.getItem("editBookingMode") === "true";
      const booking = JSON.parse(sessionStorage.getItem("newBooking"));
      const oldBooking = JSON.parse(sessionStorage.getItem("oldBooking"));
      const [therapistResponse, allTherapistsRaw] = await Promise.all([
        TherapistService.store(
          isEditMode ? {
            date,
            time,
            duration,
            lng: longitude,
            lat: latitude,
            zip_code: zipCode,
            products,
            is_duo: duo,
            status: "ACTIVE",
            booking_id: booking?.id ?? oldBooking?.id ?? 0
          } : {
            date,
            time,
            duration,
            lng: longitude,
            lat: latitude,
            zip_code: zipCode,
            products,
            is_duo: duo,
            status: "ACTIVE",
          },
          api,
          {
            with: `media,categories`,
            ...resetFormData
          }
        ),
        // Use cached allTherapists
        allTherapists.length > 0 ? Promise.resolve(allTherapists) : UserService.indexByRole(
          {
            ...resetFilters,
            status: "ACTIVE"
          },
          'ROLE_FLYPRO',
          api,
          true
        )
      ]);
      const therapistsToUse = allTherapistsRaw.sort((a, b) => {
        return (a.agent_type === "EMPLOYEE" ? -1 : 1) - (b.agent_type === "EMPLOYEE" ? -1 : 1);
      });

      let processedTherapists = therapistResponse;
      if (duo) {
        const flattened = [].concat(...Object.values(therapistResponse));
        processedTherapists = Array.from(
          new Map(flattened.map(t => [t.id, t])).values()
        );
      }

      setTherapist(processedTherapists);

      const therapistIds = new Set(processedTherapists.map(t => t.id));
      const filteredTherapists = zipCode
        ? therapistsToUse.filter(therapist =>
          !therapistIds.has(therapist.id) &&
          therapist.zones?.some(zone => {
            const [startZip, endZip] = zone.zip_code.split("-").map(Number);
            return zipCode >= startZip && zipCode <= endZip;
          })
        )
        : therapistsToUse;

      setTherapistOther(filteredTherapists);

    } catch (error) {
      console.error("Error in reset filter API call:", error);
    }
  };

  const civilityLabels = {
    MS: "Femme",
    MR: "Homme",
  };

  const [tagsLabels, setTagsLabels] = useState({});

  useEffect(() => {
    setTagsLabels({
      "contains:french": getTranslation('french', 'French'),
      "contains:english": getTranslation('english', 'English'),
      "contains:german": getTranslation('german', 'German'),
      "contains:italian": getTranslation('italian', 'Italian'),
      "contains:spanish": getTranslation('spanish', 'Spanish'),
      "contains:arabic": getTranslation('arabic', 'Arabic'),
      "contains:portuguese": getTranslation('portuguese', 'Portuguese'),
      "contains:russian": getTranslation('russian', 'Russian')
    });
  }, [i18n.language]);

  const getFilterText = () => {
    let filters = [];


    if (formData.civility && civilityLabels[formData.civility]) {
      filters.push(civilityLabels[formData.civility]);
    }


    if (formData.tags && tagsLabels[formData.tags]) {
      filters.push(tagsLabels[formData.tags]);
    }


    if (formData.is_asca === "1") {
      filters.push("ASCA");
    }


    if (formData.is_rme === "1") {
      filters.push("RME");
    }
    return filters.length > 0 ? `Filter: ${filters.join(" - ")}` : "";
  };


  const getMonthName = (date) => {
    if (!date || isNaN(date.getTime())) {
      const fallback = new Date().toLocaleString(i18n.language, { month: 'long' });
      return fallback.charAt(0).toUpperCase() + fallback.slice(1);
    }
    const monthName = date.toLocaleString(i18n.language, { month: 'long' });
    return monthName.charAt(0).toUpperCase() + monthName.slice(1);
  };

  const getDayName = (date) => {
    if (!date || isNaN(date.getTime())) {
      return new Date().toLocaleString(i18n.language, { weekday: 'short' });
    }
    return date.toLocaleString(i18n.language, { weekday: 'short' });
  };

  const getNextHourSlots = (date) => {
    const now = new Date();
    const hours = [];

    if (date?.toDateString() === now?.toDateString()) {
      const minutes = now.getMinutes();
      const nextQuarterHour = Math.ceil(minutes / 15) * 15;
      now.setMinutes(nextQuarterHour);
      now.setSeconds(0);

      for (let i = 0; i < 57; i++) {
        const slot = new Date(now.getTime() + i * 15 * 60000);
        if (slot.getHours() >= 8 && slot.getHours() < 22) {
          hours.push(slot.toLocaleTimeString('en-CA', { timeZone: 'Europe/Zurich', hour: '2-digit', minute: '2-digit', hour12: false }));
        }
      }
    } else {
      const startOfDay = new Date(date);
      startOfDay.setHours(8, 0, 0, 0);
      for (let i = 0; i < 57; i++) {
        const slot = new Date(startOfDay.getTime() + i * 15 * 60000);
        if (slot.getHours() >= 8 && slot.getHours() < 22) {
          hours.push(slot.toLocaleTimeString('en-CA', { timeZone: 'Europe/Zurich', hour: '2-digit', minute: '2-digit', hour12: false }));
        }
      }
    }

    return hours;
  };

  const scrollLeft = () => {
    const container = document.querySelector('.row-day');
    if (!container) return;

    const dayWidth = container.querySelector('.btn-hour')?.offsetWidth || 0;
    const visibleItems = Math.floor(container.clientWidth / dayWidth);
    const scrollDistance = dayWidth * (visibleItems - 0.5);

    container.scrollBy({ left: -scrollDistance, behavior: 'smooth' });
  };

  const scrollRight = () => {
    const container = document.querySelector('.row-day');
    if (!container) return;

    const dayWidth = container.querySelector('.btn-hour')?.offsetWidth || 0;
    const visibleItems = Math.floor(container.clientWidth / dayWidth);
    const scrollDistance = dayWidth * (visibleItems - 0.5);

    container.scrollBy({ left: scrollDistance, behavior: 'smooth' });
  };

  const [showPopup, setShowPopup] = useState(false);

  // const hours = getNextHourSlots(selectedDate);
  // sessionStorage.removeItem("previousPath");
  const selectedProfileDateString = modalIsOpen2 && selectedDate ? selectedDate.toDateString() : null;
  const isSelectedProfileDateValidating =
    Boolean(selectedProfileDateString && profileValidatingDateString === selectedProfileDateString);
  const dateAvailabilityForDisplay = isSelectedProfileDateValidating
    ? unavailableDates.filter((date) => date !== selectedProfileDateString)
    : unavailableDates;
  const hideSelectedProfileDateAvailability =
    Boolean(
      modalIsOpen2
      && selectedProfileDateString
      && !isSelectedProfileDateValidating
      && !dateAvailabilityForDisplay.includes(selectedProfileDateString)
    );

  return (
    <>
      <MenuHeader />
      <Nav page="therapist" />
      <div className={`container ${!modalIsOpen2 && 'container-therapeut'}`}>
        {!modalIsOpen2 && <h2 style={{ textAlign: 'center', fontWeight: 700, color: '#000000' }}>{getTranslation('choose_therapist_and_date', 'Choose your therapist and date')}</h2>}      </div>
      <form className="form-masseur booking-therapist-page booking-therapist-page--normal" onSubmit={handleSubmit}>
        {modalIsOpen2 ? <>
          <div className="contentModal">

            <HeaderTherapist currentTherapist={currentTherapist} closeModal2={closeModal2} />
            {/* <form className="form-masseur" onSubmit={handleSubmit}> */}
            <DateTimeSelector selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              selectedDateScroll={selectedDateScroll}
              selectedTime={selectedTime}
              modalIsOpen2={modalIsOpen2}
              setSelectedTime={setSelectedTime}
              handleMonthChange={handleMonthChange}
              handleDayChange={handleDayChange}
              handleDayClick={handleDayClick}
              handleHourClick={handleHourClick}
              daysToShow={daysToShow}
              hours={hours}
              totalPrice={totalPrice}
              scrollLeft={scrollLeft}
              scrollRight={scrollRight}
              openModal={openModal}
              getMonthName={getMonthName}
              getDayName={getDayName}
              getFilterText={getFilterText()}
              handleResetFilter={handleResetFilter}
              unavailableDates={dateAvailabilityForDisplay}
              pendingDateStrings={isSelectedProfileDateValidating ? [selectedProfileDateString] : []}
              availableHours={availableHours}
              buffertime={buffertime}
              totalDuration={totalDuration}
              isEditMode={false}
              currentTherapist={currentTherapist}
              hideSelectedDateAvailability={hideSelectedProfileDateAvailability}
            />

            {/* </form> */}
            <ReviewList currentTherapist={currentTherapist} />
            <Informations currentTherapist={currentTherapist} axios={api} auth={auth} />
          </div></> : <>
          <div className={`container ${!modalIsOpen2 && 'container-therapeut'}`}>
            <DateTimeSelector
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              selectedDateScroll={selectedDateScroll}
              selectedTime={selectedTime}
              setSelectedTime={setSelectedTime}
              handleMonthChange={handleMonthChange}
              handleDayChange={handleDayChange}
              handleDayClick={handleDayClick}
              handleHourClick={handleHourClick}
              daysToShow={daysToShow}
              hours={hours}
              totalPrice={totalPrice}
              scrollLeft={scrollLeft}
              scrollRight={scrollRight}
              openModal={openModal}
              getMonthName={getMonthName}
              getDayName={getDayName}
              getFilterText={getFilterText()}
              unavailableDates={unavailableDates}
              availableHours={availableHours}
              buffertime={buffertime}
              totalDuration={totalDuration}
              handleResetFilter={handleResetFilter}
            />
            <p className="therapist-selection-guidance">{getTranslation('select_therapist_zone', 'Please select a time slot. Here are all the flypros operating in your area.')}</p>
            <div className="form-group group-masseur">
              {therapists.length > 0 && selectedDate && selectedTime &&
                <div className="therapist-item" onClick={() => { addedTherapist({ id: 0 }); }}>
                  {/* <img src={user} alt="default" className="therapist-image" /> */}
                  <div className="therapist-info">
                    <p className="name" style={{ marginLeft: '50px', fontWeight: 700 }}>{getTranslation('no_preference', 'No preference')}</p>                    <button
                      type="button"
                      className={`btn-outline-primary default ${selectedTherapist.some(t => t.id === 0) ? 'selected' : ''}`}

                    >
                      &gt;
                    </button>
                  </div>
                </div>
              }
              {therapists.length > 0 && therapists?.map((therapist) => (
                <div
                  key={therapist.id}
                  className={`therapist-item ${!selectedTime ? 'therapist-item--awaiting-time' : ''}`}
                  onClick={() => {
                    if (!selectedDate || !selectedTime) {
                      openModal2(therapist);
                      return;
                    }
                    addedTherapist(therapist);
                  }}
                >
                  <img src={therapist.media?.length ? therapist.media[0].original_url : user} alt={therapist?.name} className="therapist-image" />
                  <div className="therapist-info">
                    <p className="name">
                      <span className="flypro-card-meta__name-text">{therapist?.firstname}</span>
                      <Tooltip title={getTranslation('more_info', 'More information')} placement="top" arrow slotProps={{
                        popper: {
                          sx: {
                            '& .MuiTooltip-tooltip': {
                              backgroundColor: '#393d44',
                              color: '#fff',
                              fontSize: '1rem',
                              padding: '8px 12px',
                              borderRadius: '8px'
                            },
                            '& .MuiTooltip-arrow': {
                              color: '#393d44',
                            }
                          }
                        }
                      }}><IconButton onClick={(e) => {
                        e.stopPropagation();
                        openModal2(therapist);
                      }}
                      ><InfoIcon /></IconButton></Tooltip>
                    </p>
                    <FlyproCardMetadata therapist={therapist} />
                    {selectedTherapist.some(t => t.id === therapist.id) && (
                      <span className="therapist-selection-indicator" aria-hidden="true" />
                    )}
                  </div>
                </div>
              ))}

            </div>
            {therapistsOther.length > 0 && !duo && (
              <>
                <div className='other' style={{ textAlign: 'center', fontWeight: 700, marginTop: 24, marginBottom: 8 }}>{getTranslation('available_other_slots', 'Available on other slots')}</div>
                <div className="form-group group-masseur">
                  {therapistsOther?.map((therapist) => (
                    // <div key={therapist.id} className="therapist-item" onClick={() => addedTherapist(therapist)}>
                    <div key={therapist.id} className="therapist-item" onClick={() => openModal2(therapist)}>
                      <img src={therapist.media?.length ? therapist.media[0].original_url : user} alt={therapist?.name} className="therapist-image" />
                      <div className="therapist-info">
                        <p className="name">
                          <span className="flypro-card-meta__name-text">{therapist?.firstname}</span>
                          <Tooltip title={getTranslation('more_info', 'More information')} placement="top" arrow slotProps={{
                            popper: {
                              sx: {
                                '& .MuiTooltip-tooltip': {
                                  backgroundColor: '#393d44',
                                  color: '#fff',
                                  fontSize: '1rem',
                                  padding: '8px 12px',
                                  borderRadius: '8px'
                                },
                                '& .MuiTooltip-arrow': {
                                  color: '#393d44',
                                }
                              }
                            }
                          }}>
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                openModal2(therapist);
                              }}
                            >
                              <InfoIcon /></IconButton></Tooltip>
                        </p>
                        <FlyproCardMetadata therapist={therapist} />
                        <button
                          type="button"
                          className="btn-outline-primary"
                        >
                          &gt;
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
            {/* Show message when no therapists are available at selected time but there are therapists available on other slots */}
            {therapists.length === 0 && therapistsOther.length > 0 && selectedTime && (
              <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                No therapists available at {selectedTime}, but you can choose from therapists available on other slots below.
              </div>
            )}
          </div>

        </>}

        <div className='btn-bottom'>
          <button type="submit" className="btn btn-primary" disabled={!selectedTime || (modalIsOpen2 && duo)}>
            {getTranslation('next', 'Next')}
          </button>
        </div>

      </form>
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <p>{getTranslation('no_service_sunday', 'No service on Sunday')}</p>
            <button onClick={redirectToPartnerHotels} className="btn redirect-button">
              {getTranslation('choose_partner_hotel', 'Choose partner hotel')}
            </button>
            <button onClick={() => setShowPopup(false)} className="btn close-button">
              {getTranslation('close', 'Close')}
            </button>
          </div>
        </div>
      )}


      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="contentModal">
          <div className="headerModal modal-icone">
            <a onClick={closeModal}>
              <img src={back} alt="Fermer" />
            </a>
            <a onClick={closeModal}>
              <img src={croix} alt="Fermer" />
            </a>
          </div>
          <div className="form-inscription">
            <form onSubmit={handleSubmitFilter}>

              <div className="form-choix">
                <div className="form-radio">
                  <input
                    type="checkbox"
                    name="civility"
                    value="MR"
                    checked={formData.civility === "MR"}
                    id="monsieur"
                    onChange={handleChange}
                  />
                  <label htmlFor="monsieur">{getTranslation('male', 'Male')}</label>
                </div>
                <div className="form-radio">
                  <input
                    type="checkbox"
                    name="civility"
                    value="MS"
                    id="madame"
                    checked={formData.civility === "MS"}
                    onChange={handleChange}
                  />
                  <label htmlFor="madame">{getTranslation('female', 'Female')}</label>
                </div>
              </div>
              <div className='flex-row gap-10'>
                <div className="form-text">
                  <label>{getTranslation('language', 'Language')}</label>
                  <select
                    defaultValue=""
                    name="tags"
                    onChange={handleChange}
                  >
                    <option value="" disabled hidden>{getTranslation('select_language', 'Select language')}</option>
                    <option value="contains:french">{getTranslation('french', 'French')}</option>
                    <option value="contains:english">{getTranslation('english', 'English')}</option>
                    <option value="contains:german">{getTranslation('German', 'German')}</option>
                    <option value="contains:italian">{getTranslation('Italian', 'Italian')}</option>
                    <option value="contains:spanish">{getTranslation('Spanish', 'Spanish')}</option>
                    <option value="contains:arabic">{getTranslation('Arabic', 'Arabic')}</option>
                    <option value="contains:portuguese">{getTranslation('Portuguese', 'Portuguese')}</option>
                    <option value="contains:russian">{getTranslation('Russian', 'Russian')}</option>
                  </select>
                </div>
              </div>
              <div className="form-choix">
                <div className="form-radio">
                  <input
                    type="checkbox"
                    name="is_asca"
                    value="1"
                    id="is_asca"
                    checked={formData.is_asca === "1"}
                    onChange={handleChange}
                  />
                  <label htmlFor="is_asca">{getTranslation('asca', 'ASCA')}</label>
                </div>
                <div className="form-radio">
                  <input
                    type="checkbox"
                    name="is_rme"
                    value="1"
                    id="is_rme"
                    checked={formData.is_rme === "1"}
                    onChange={handleChange}
                  />
                  <label htmlFor="is_rme">{getTranslation('rme', 'RME')}</label>
                </div>
              </div>

              <div className="form-button">
                <button className='btn-submit' type="submit">{getTranslation('filter', 'Filter')}</button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={modalIsPaiementOpen}
        onRequestClose={closeModalPaiement}
        style={customStyles2}
        contentLabel="Paiement Modal"
        id="custom-popup-content"
      >
        <div className="contentModal">
          <div className="modal">
            <p className="modal-text2 text-message" style={{ whiteSpace: 'pre-line' }}>
              {modalMessage}
            </p>
            <div className="modal-button-container">
              <button className="modal-ok-button" onClick={redirectToHome}>
                OK
              </button>
              <button className="modal-cancel-button" onClick={closeModalPaiement}>
                Annuler
              </button>
            </div>
          </div>
        </div>
      </Modal>

    </>
  );
}
export default ChooseTherapist;
